module.exports = __webpack_public_path__ + "static/media/w4.87aabc4a.png";